/*
 * HelianWell — lightweight image slideshow (study/research section, etc.)
 * Loaded once globally from layout/theme.liquid. Uses a delegated click
 * listener on `document` (survives section re-renders) for arrows + dots,
 * and binds a scroll listener per track to keep the active dot in sync.
 * Markup contract: [data-hw-slideshow] > .hw-slides > .hw-slide,
 * plus [data-hw-slide-prev] / [data-hw-slide-next] / [data-hw-slide-dot="i"].
 */
(function () {
  if (window.__hwSlideshow) return;
  window.__hwSlideshow = true;

  function track(el) {
    var sw = el.closest('[data-hw-slideshow]');
    return sw ? sw.querySelector('.hw-slides') : null;
  }

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('[data-hw-slide-prev], [data-hw-slide-next]');
    if (arrow) {
      var t = track(arrow);
      if (t) {
        var slide = t.querySelector('.hw-slide');
        var step = slide ? slide.getBoundingClientRect().width : t.clientWidth;
        var dir = arrow.hasAttribute('data-hw-slide-next') ? 1 : -1;
        t.scrollBy({ left: dir * step, behavior: 'smooth' });
      }
      return;
    }

    var dot = event.target.closest('[data-hw-slide-dot]');
    if (dot) {
      var t2 = track(dot);
      if (t2) {
        var slides = t2.querySelectorAll('.hw-slide');
        var i = parseInt(dot.getAttribute('data-hw-slide-dot'), 10) || 0;
        if (slides[i]) {
          t2.scrollTo({ left: slides[i].offsetLeft - t2.offsetLeft, behavior: 'smooth' });
        }
      }
    }
  });

  function syncDots(sw) {
    var t = sw.querySelector('.hw-slides');
    if (!t || t.__hwBound) return;
    t.__hwBound = true;
    var dots = sw.querySelectorAll('[data-hw-slide-dot]');
    var slides = t.querySelectorAll('.hw-slide');
    function update() {
      var idx = 0, min = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs(slides[i].offsetLeft - t.offsetLeft - t.scrollLeft);
        if (d < min) { min = d; idx = i; }
      }
      for (var j = 0; j < dots.length; j++) {
        dots[j].classList.toggle('is-active', j === idx);
      }
    }
    t.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    update();
  }

  function init() {
    document.querySelectorAll('[data-hw-slideshow]').forEach(syncDots);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  // Re-bind when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
